export const oneSignalConstants = {
  SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_REQUEST:
    "SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_REQUEST",
  SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_SUCCESS:
    "SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_SUCCESS",
  SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_FAILURE:
    "SET_ONESIGNAL_DEVICE_TOKEN_FOR_NOTIFICATION_ACTION_FAILURE",

  REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_REQUEST:
    "REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_REQUEST",
  REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_SUCCESS:
    "REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_SUCCESS",
  REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_FAILURE:
    "REGISTER_ONESIGNAL_CLIENT_TOKEN_FOR_NOTIFICATION_ACTION_FAILURE",
};
